// PRD-3334 v2.2: the pass the backend issues after the Cloudflare check on /signup.
// Kept in sessionStorage for this tab only, with its expiry.

const KEY = "plgHumanPass";
const SKEW_MS = 10_000;

interface Stored {
  humanPass: string;
  expiresAt: number;
}

export function saveHumanPass(humanPass: string, expiresInSeconds: number): void {
  try {
    const value: Stored = { humanPass, expiresAt: Date.now() + expiresInSeconds * 1000 };
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // storage blocked: the gate simply shows again next time
  }
}

/** The pass if it is still valid (with a small margin), else null. */
export function getHumanPass(): string | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as Stored;
    if (!value.humanPass || value.expiresAt - SKEW_MS <= Date.now()) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return value.humanPass;
  } catch {
    return null;
  }
}

export function clearHumanPass(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
